module.exports = __webpack_public_path__ + "static/media/se_2.770beeff.mp3";